var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFooterBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1366,
    height: 515,
    viewBox: "0 0 1366 515",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_644_7325)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M402.406 167.92H334.758V447.728H402.406V167.92Z",
    fill: "#AD9A7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.358 147.857H345.812V265.453H391.358V147.857Z",
    fill: "#AD9A7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.213 135.137H355.945V200.356H381.213V135.137Z",
    fill: "#AD9A7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.191 168.651H359.961V124.191H366.173H372.335H377.191V168.651Z",
    fill: "#AD9A7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.446 149.301H365.57V104.842H366.257H366.91H367.446V149.301Z",
    fill: "#AD9A7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.579 133.936H369.703V89.4766H370.373H371.043H371.579V133.936Z",
    fill: "#AD9A7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.201 167.207H332.953V170.183H404.201V167.207Z",
    fill: "#AD9A7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.001 146.43H344.141V149.301H393.001V146.43Z",
    fill: "#AD9A7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.266 133.936H354.102V136.128H382.266V133.936Z",
    fill: "#AD9A7A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M352.11 152.625H350V164.945H352.11V152.625Z",
    fill: "#AD9A7A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M357.969 152.625H355.859V164.945H357.969V152.625Z",
    fill: "#AD9A7A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M363.813 152.625H361.703V164.945H363.813V152.625Z",
    fill: "#AD9A7A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M369.672 152.625H367.562V164.945H369.672V152.625Z",
    fill: "#AD9A7A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M375.532 152.625H373.422V164.945H375.532V152.625Z",
    fill: "#AD9A7A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M381.399 152.625H379.289V164.945H381.399V152.625Z",
    fill: "#AD9A7A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M387.258 152.625H385.148V164.945H387.258V152.625Z",
    fill: "#AD9A7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.811 179.074H340.688V193.691H345.811V179.074Z",
    fill: "#AD9A7A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M355.944 179.074H350.82V193.691H355.944V179.074Z",
    fill: "#AD9A7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.077 179.074H360.953V193.691H366.077V179.074Z",
    fill: "#AD9A7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.202 179.074H371.078V193.691H376.202V179.074Z",
    fill: "#AD9A7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.318 179.074H381.211V193.691H386.318V179.074Z",
    fill: "#AD9A7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.451 179.074H391.344V193.691H396.451V179.074Z",
    fill: "#AD9A7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.811 201.869H340.688V216.486H345.811V201.869Z",
    fill: "#AD9A7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.944 201.869H350.82V216.486H355.944V201.869Z",
    fill: "#AD9A7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.077 201.869H360.953V216.486H366.077V201.869Z",
    fill: "#AD9A7A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M376.202 201.869H371.078V216.486H376.202V201.869Z",
    fill: "#AD9A7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.318 201.869H381.211V216.486H386.318V201.869Z",
    fill: "#AD9A7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.451 201.869H391.344V216.486H396.451V201.869Z",
    fill: "#AD9A7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.811 224.648H340.688V239.265H345.811V224.648Z",
    fill: "#AD9A7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.944 224.648H350.82V239.265H355.944V224.648Z",
    fill: "#AD9A7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.077 224.648H360.953V239.265H366.077V224.648Z",
    fill: "#AD9A7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.202 224.648H371.078V239.265H376.202V224.648Z",
    fill: "#AD9A7A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M386.318 224.648H381.211V239.265H386.318V224.648Z",
    fill: "#AD9A7A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M396.451 224.648H391.344V239.265H396.451V224.648Z",
    fill: "#AD9A7A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M345.811 247.426H340.688V262.043H345.811V247.426Z",
    fill: "#AD9A7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.944 247.426H350.82V262.043H355.944V247.426Z",
    fill: "#AD9A7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.077 247.426H360.953V262.043H366.077V247.426Z",
    fill: "#AD9A7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.202 247.426H371.078V262.043H376.202V247.426Z",
    fill: "#AD9A7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.318 247.426H381.211V262.043H386.318V247.426Z",
    fill: "#AD9A7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.451 247.426H391.344V262.043H396.451V247.426Z",
    fill: "#AD9A7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.811 270.221H340.688V284.838H345.811V270.221Z",
    fill: "#AD9A7A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M355.944 270.221H350.82V284.838H355.944V270.221Z",
    fill: "#AD9A7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.077 270.221H360.953V284.838H366.077V270.221Z",
    fill: "#AD9A7A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M376.202 270.221H371.078V284.838H376.202V270.221Z",
    fill: "#AD9A7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.318 270.221H381.211V284.838H386.318V270.221Z",
    fill: "#AD9A7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.451 270.221H391.344V284.838H396.451V270.221Z",
    fill: "#AD9A7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.811 292.998H340.688V307.615H345.811V292.998Z",
    fill: "#AD9A7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.944 292.998H350.82V307.615H355.944V292.998Z",
    fill: "#AD9A7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.077 292.998H360.953V307.615H366.077V292.998Z",
    fill: "#AD9A7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.202 292.998H371.078V307.615H376.202V292.998Z",
    fill: "#AD9A7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.318 292.998H381.211V307.615H386.318V292.998Z",
    fill: "#AD9A7A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M396.451 292.998H391.344V307.615H396.451V292.998Z",
    fill: "#AD9A7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.811 315.795H340.688V330.412H345.811V315.795Z",
    fill: "#AD9A7A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M355.944 315.795H350.82V330.412H355.944V315.795Z",
    fill: "#AD9A7A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M366.077 315.795H360.953V330.412H366.077V315.795Z",
    fill: "#AD9A7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.202 315.795H371.078V330.412H376.202V315.795Z",
    fill: "#AD9A7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.318 315.795H381.211V330.412H386.318V315.795Z",
    fill: "#AD9A7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.451 315.795H391.344V330.412H396.451V315.795Z",
    fill: "#AD9A7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.811 338.572H340.688V353.189H345.811V338.572Z",
    fill: "#AD9A7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.944 338.572H350.82V353.189H355.944V338.572Z",
    fill: "#AD9A7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.077 338.572H360.953V353.189H366.077V338.572Z",
    fill: "#AD9A7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.202 338.572H371.078V353.189H376.202V338.572Z",
    fill: "#AD9A7A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M386.318 338.572H381.211V353.189H386.318V338.572Z",
    fill: "#AD9A7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.451 338.572H391.344V353.189H396.451V338.572Z",
    fill: "#AD9A7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.811 361.367H340.688V375.984H345.811V361.367Z",
    fill: "#AD9A7A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M355.944 361.367H350.82V375.984H355.944V361.367Z",
    fill: "#AD9A7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.077 361.367H360.953V375.984H366.077V361.367Z",
    fill: "#AD9A7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.202 361.367H371.078V375.984H376.202V361.367Z",
    fill: "#AD9A7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.318 361.367H381.211V375.984H386.318V361.367Z",
    fill: "#AD9A7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.451 361.367H391.344V375.984H396.451V361.367Z",
    fill: "#AD9A7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.811 384.145H340.688V398.761H345.811V384.145Z",
    fill: "#AD9A7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.944 384.145H350.82V398.761H355.944V384.145Z",
    fill: "#AD9A7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.077 384.145H360.953V398.761H366.077V384.145Z",
    fill: "#AD9A7A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M376.202 384.145H371.078V398.761H376.202V384.145Z",
    fill: "#AD9A7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.318 384.145H381.211V398.761H386.318V384.145Z",
    fill: "#AD9A7A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M396.451 384.145H391.344V398.761H396.451V384.145Z",
    fill: "#AD9A7A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M345.811 406.941H340.688V421.558H345.811V406.941Z",
    fill: "#AD9A7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.944 406.941H350.82V421.558H355.944V406.941Z",
    fill: "#AD9A7A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M366.077 406.941H360.953V421.558H366.077V406.941Z",
    fill: "#AD9A7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.202 406.941H371.078V421.558H376.202V406.941Z",
    fill: "#AD9A7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.318 406.941H381.211V421.558H386.318V406.941Z",
    fill: "#AD9A7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.451 406.941H391.344V421.558H396.451V406.941Z",
    fill: "#AD9A7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.044 178.568H138.305V414.282H247.044V178.568Z",
    fill: "#AD9A7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.121 174.514H135.203V181.178H250.121V174.514Z",
    fill: "#AD9A7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.392 165.988H141.953V197.658H243.392V165.988Z",
    fill: "#AD9A7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.889 153.023H149.719V187.617H189.889V153.023Z",
    fill: "#AD9A7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.96 162.768H149.719V144.566H166.38L172.96 162.768Z",
    fill: "#AD9A7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.339 129.445H159.078V170.007H161.339V129.445Z",
    fill: "#AD9A7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.232 127.34C162.232 128.506 161.328 129.445 160.206 129.445C159.084 129.445 158.18 128.506 158.18 127.34C158.18 126.174 159.084 125.234 160.206 125.234C161.328 125.234 162.232 126.174 162.232 127.34Z",
    fill: "#AD9A7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1147.55 432.224H1028.51L1013.66 85.6484L1147.55 114.534V432.224Z",
    fill: "#AD9A7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M628.214 234.304V118.431H609.544V87.4052H602.879V41.8842H566.125V8.42208H562.86V41.8842H555.66V0H552.395V41.8842H529.17V118.431H517.164V234.304H506.883V445.344H635.448V234.304H628.214Z",
    fill: "#AD9A7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1408.55 427.926H-13.6875V463.076H1408.55V427.926Z",
    fill: "#C9E265"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M823.492 454.461H760.516L785.046 323.414H823.492V454.461Z",
    fill: "#DFD3BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1428.57 459.578H-64.7109V515H1428.57V459.578Z",
    fill: "#DFD3BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M771.878 211.944V153.877H751.651V131.76H740.834V113.193H737.033V81.3496H736.062V113.193H732.261V131.76H721.444V153.877H701.367V211.944H697.197V317.394H666.086V437.583H697.197H728.309H775.897V211.944H771.878Z",
    fill: "#DFD3BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M888.091 278.66H790.219V280.505H794.639V452.496H883.67V280.505H888.091V278.66Z",
    fill: "#DFD3BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.779 321.5H354.992V464.78H441.779V321.5Z",
    fill: "#DFD3BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.916 394.916H192.672V464.781H341.916V394.916Z",
    fill: "#DFD3BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.425 238.811H272.656V410.384H305.425V238.811Z",
    fill: "#DFD3BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.599 193.047H279.891V286.351H281.599V193.047Z",
    fill: "#DFD3BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.145 200.111H285.438V293.415H287.145V200.111Z",
    fill: "#DFD3BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.214 228.197H275.188V251.184H295.214V228.197Z",
    fill: "#DFD3BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.086 347.15H336.07V464.781H393.086V347.15Z",
    fill: "#DFD3BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.859 222.68H455.828V464.78H562.859V222.68Z",
    fill: "#DFD3BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552.344 214.346H466.344V254.664H552.344V214.346Z",
    fill: "#DFD3BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.164 227.744H447.539V230.58H571.164V227.744Z",
    fill: "#DFD3BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.872 342.504H436.438V464.763H486.872V342.504Z",
    fill: "#DFD3BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.096 337.857H75.2266V464.763H133.096V337.857Z",
    fill: "#DFD3BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.265 303.369H93.9453V464.763H209.265V303.369Z",
    fill: "#DFD3BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.226 297.174H87.2109V303.369H212.226V297.174Z",
    fill: "#DFD3BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.716 280.383H99.0469V313.114H149.716V280.383Z",
    fill: "#DFD3BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.788 280.383H166.281V300.29H174.788V280.383Z",
    fill: "#DFD3BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.665 280.383H183.305V300.29H192.665V280.383Z",
    fill: "#DFD3BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.158 415.693H43.7266V464.782H104.158V415.693Z",
    fill: "#DFD3BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.5384 394.916H20.9219V464.781H49.5384V394.916Z",
    fill: "#DFD3BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2067 440.229H-13.6875V464.764H35.2067V440.229Z",
    fill: "#DFD3BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1154.9 410.385H552.344V464.78H1154.9V410.385Z",
    fill: "#DFD3BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1106.79 259.832C1102.99 259.832 1099.89 262.86 1099.57 266.723L1091.1 266.444C1091.11 265.574 1091.13 264.722 1091.13 263.852C1091.13 252.889 1089.31 242.205 1085.82 232.199L1092.91 229.485C1094.01 232.147 1096.57 234.026 1099.55 234.026C1103.55 234.026 1106.79 230.651 1106.79 226.509C1106.79 222.368 1103.54 218.992 1099.55 218.992C1095.57 218.992 1092.32 222.368 1092.32 226.509C1092.32 227.275 1092.44 228.023 1092.64 228.719L1085.55 231.434C1081.52 220.193 1075.36 209.787 1067.3 200.79L1072.85 195.396C1074.15 196.684 1075.91 197.484 1077.85 197.484C1081.85 197.484 1085.09 194.108 1085.09 189.967C1085.09 185.826 1081.84 182.45 1077.85 182.45C1073.87 182.45 1070.62 185.826 1070.62 189.967C1070.62 191.812 1071.25 193.499 1072.31 194.804L1066.77 200.199C1066.2 199.572 1065.61 198.946 1065.03 198.337C1056.64 189.619 1046.86 182.85 1036.22 178.239L1039.27 170.53C1039.96 170.756 1040.7 170.878 1041.47 170.878C1045.47 170.878 1048.7 167.502 1048.7 163.361C1048.7 159.219 1045.45 155.844 1041.47 155.844C1037.48 155.844 1034.23 159.219 1034.23 163.361C1034.23 166.423 1035.99 169.068 1038.54 170.234L1035.49 177.926C1025.96 173.923 1015.76 171.626 1005.25 171.244L1005.58 160.699C1005.58 160.699 1005.73 160.699 1005.82 160.699C1009.82 160.699 1013.05 157.323 1013.05 153.181C1013.05 149.04 1009.8 145.664 1005.82 145.664C1001.83 145.664 998.583 149.04 998.583 153.181C998.583 156.975 1001.28 160.107 1004.8 160.629L1004.46 171.226C1003.62 171.209 1002.8 171.191 1001.97 171.191C991.835 171.191 981.972 172.931 972.662 176.29L969.749 167.676C972.378 166.545 974.236 163.866 974.236 160.716C974.236 156.557 970.988 153.199 967.003 153.199C963.018 153.199 959.769 156.574 959.769 160.716C959.769 164.857 963.018 168.233 967.003 168.233C967.689 168.233 968.359 168.129 968.995 167.937L971.909 176.551C960.64 180.727 950.225 187.287 941.25 195.953L935.958 190.089C937.147 188.749 937.867 186.957 937.867 185.008C937.867 180.849 934.619 177.49 930.634 177.49C926.648 177.49 923.4 180.866 923.4 185.008C923.4 189.149 926.648 192.525 930.634 192.525C932.459 192.525 934.116 191.829 935.389 190.663L940.664 196.527C940.061 197.119 939.458 197.728 938.872 198.337C931.404 206.098 925.426 214.99 921.089 224.647L914.358 221.428C914.609 220.68 914.743 219.862 914.743 219.027C914.743 214.868 911.495 211.509 907.509 211.509C903.524 211.509 900.276 214.885 900.276 219.027C900.276 223.168 903.524 226.544 907.509 226.544C910.423 226.544 912.918 224.769 914.073 222.194L920.754 225.395C915.949 236.306 913.236 248.173 912.817 260.476L904.194 260.18C904.093 256.126 900.895 252.872 896.96 252.872C893.025 252.872 889.727 256.247 889.727 260.389C889.727 264.53 892.975 267.906 896.96 267.906C900.945 267.906 903.859 264.878 904.177 261.015L912.801 261.311C912.784 262.181 912.767 263.034 912.767 263.904C912.767 274.867 914.592 285.551 918.075 295.556L910.992 298.271C909.887 295.608 907.325 293.729 904.345 293.729C900.343 293.729 897.111 297.105 897.111 301.246C897.111 305.388 900.359 308.764 904.345 308.764C908.33 308.764 911.578 305.388 911.578 301.246C911.578 300.481 911.461 299.733 911.26 299.036L918.343 296.322C922.378 307.58 928.54 317.969 936.595 326.965L931.052 332.359C929.746 331.072 927.988 330.271 926.046 330.271C922.044 330.271 918.812 333.647 918.812 337.788C918.812 341.93 922.06 345.306 926.046 345.306C930.031 345.306 933.279 341.93 933.279 337.788C933.279 335.944 932.643 334.256 931.588 332.951L937.13 327.557C937.7 328.183 938.286 328.81 938.872 329.419C944.532 335.3 950.811 340.277 957.559 344.314L913.906 427.943H906.069V430.327H902.235V435.078H1101.73V430.327H1097.9V427.943H1090.06L1046.41 344.314C1052.22 340.834 1057.69 336.64 1062.71 331.803L1069.8 339.65C1068.27 341.025 1067.32 343.061 1067.32 345.323C1067.32 349.482 1070.57 352.84 1074.55 352.84C1078.54 352.84 1081.79 349.465 1081.79 345.323C1081.79 341.182 1078.54 337.806 1074.55 337.806C1073.01 337.806 1071.61 338.311 1070.43 339.146L1063.3 331.246C1063.9 330.654 1064.51 330.045 1065.09 329.436C1072.56 321.675 1078.54 312.783 1082.88 303.126L1090.76 306.902C1090.61 307.493 1090.54 308.102 1090.54 308.746C1090.54 312.905 1093.79 316.263 1097.78 316.263C1101.76 316.263 1105.01 312.888 1105.01 308.746C1105.01 304.605 1101.76 301.229 1097.78 301.229C1094.68 301.229 1092.03 303.265 1091 306.101L1083.21 302.36C1088.02 291.45 1090.73 279.582 1091.15 267.28L1099.64 267.558C1099.74 271.612 1102.94 274.884 1106.87 274.884C1110.81 274.884 1114.1 271.508 1114.1 267.367C1114.1 263.225 1110.86 259.849 1106.87 259.849L1106.79 259.832ZM1088.72 263.852C1088.72 264.687 1088.72 265.522 1088.69 266.357L1063.7 265.522C1063.7 264.965 1063.72 264.409 1063.72 263.852C1063.72 256.195 1062.43 248.852 1060.05 242.048L1083.55 233.052C1086.94 242.796 1088.72 253.185 1088.72 263.852ZM1062.5 265.487L1006.77 263.608C1006.75 263.225 1006.69 262.86 1006.6 262.512L1058.93 242.483C1061.26 249.165 1062.53 256.352 1062.53 263.852C1062.53 264.391 1062.53 264.931 1062.51 265.487H1062.5ZM941.317 262.233L997.043 264.113C997.059 264.495 997.126 264.861 997.21 265.209L944.883 285.237C942.556 278.555 941.283 271.369 941.283 263.869C941.283 263.33 941.283 262.79 941.3 262.233H941.317ZM1005.72 260.719L1046.37 221.115C1051.65 227.031 1055.85 234.009 1058.63 241.7L1006.3 261.711C1006.13 261.346 1005.93 261.015 1005.7 260.702L1005.72 260.719ZM1005.16 260.11C1004.85 259.815 1004.49 259.554 1004.11 259.362L1025.29 205.767C1033.09 209.178 1040.08 214.224 1045.82 220.523L1005.16 260.128V260.11ZM1003.37 259.032C1003.09 258.927 1002.77 258.875 1002.47 258.823L1004.28 200.912C1011.43 201.191 1018.24 202.774 1024.55 205.419L1003.37 259.014V259.032ZM1001.66 258.805C1001.33 258.823 1000.99 258.875 1000.68 258.962L982.14 204.323C988.335 202.096 994.983 200.877 1001.92 200.877C1002.43 200.877 1002.95 200.877 1003.49 200.895L1001.68 258.805H1001.66ZM999.923 259.24C999.554 259.414 999.203 259.641 998.884 259.884L960.774 217.635C966.685 211.962 973.667 207.49 981.37 204.584L999.906 259.223L999.923 259.24ZM998.298 260.458C998.064 260.737 997.846 261.033 997.679 261.363L947.06 237.089C950.292 229.972 954.762 223.568 960.204 218.209L998.315 260.476L998.298 260.458ZM997.327 262.112C997.193 262.477 997.11 262.86 997.059 263.26L941.333 261.381C941.652 253.011 943.527 245.059 946.692 237.82L997.311 262.094L997.327 262.112ZM997.495 265.975C997.629 266.27 997.779 266.549 997.963 266.792L997.629 267.419L957.425 306.571C952.15 300.655 947.947 293.677 945.168 285.986L997.495 265.975ZM996.406 269.768L971.172 318.108C966.299 315.115 961.862 311.426 957.977 307.198L996.406 269.768ZM999.152 268.011C999.32 268.132 999.504 268.237 999.688 268.341L978.506 321.936C976.463 321.049 974.488 320.039 972.562 318.926L999.152 267.993V268.011ZM1000.42 268.654C1000.73 268.759 1001.03 268.811 1001.33 268.863L999.521 326.774C992.371 326.495 985.556 324.912 979.243 322.267L1000.42 268.672V268.654ZM1001.9 326.808C1001.38 326.808 1000.86 326.808 1000.32 326.791L1002.13 268.881C1002.47 268.863 1002.8 268.811 1003.12 268.724L1021.66 323.363C1015.46 325.59 1008.81 326.808 1001.88 326.808H1001.9ZM1003.89 268.446C1004.16 268.324 1004.41 268.167 1004.64 268.011L1031.24 318.943C1028.42 320.562 1025.47 321.954 1022.43 323.102L1003.89 268.446ZM1008.36 271.612L1043.02 310.051C1039.86 313.096 1036.38 315.794 1032.62 318.091L1008.36 271.612ZM1006.84 268.707L1005.83 266.792C1005.93 266.636 1006.03 266.479 1006.12 266.323L1056.74 290.597C1053.51 297.714 1049.03 304.118 1043.59 309.477L1006.82 268.707H1006.84ZM1006.47 265.557C1006.6 265.192 1006.69 264.809 1006.74 264.408L1062.46 266.288C1062.15 274.658 1060.27 282.61 1057.11 289.849L1006.49 265.574L1006.47 265.557ZM978.037 323.085L968.527 347.15C965.63 345.897 962.8 344.471 960.037 342.887L971.976 320.005C973.935 321.136 975.961 322.162 978.037 323.067V323.085ZM978.774 323.398C985.204 326.112 992.187 327.713 999.471 328.009L998.65 353.971C988.419 353.589 978.506 351.361 969.247 347.463L978.757 323.398H978.774ZM1000.27 328.044C1000.81 328.044 1001.35 328.061 1001.88 328.061C1008.95 328.061 1015.73 326.826 1022.04 324.546L1030.36 349.082C1021.32 352.336 1011.73 354.024 1001.86 354.024C1001.06 354.024 1000.26 354.024 999.454 353.989L1000.26 328.027L1000.27 328.044ZM1022.81 324.268C1025.93 323.102 1028.94 321.675 1031.8 320.022L1043.74 342.904C1039.69 345.219 1035.49 347.202 1031.13 348.803L1022.81 324.268ZM1083.24 232.251L1059.75 241.248C1056.9 233.4 1052.62 226.283 1047.24 220.245L1065.51 202.461C1073.35 211.214 1079.33 221.324 1083.26 232.269L1083.24 232.251ZM1063.27 200.042C1063.84 200.634 1064.41 201.243 1064.96 201.852L1046.69 219.636C1040.83 213.215 1033.7 208.064 1025.74 204.584L1035.25 180.518C1045.6 184.99 1055.11 191.585 1063.27 200.06V200.042ZM1034.5 180.188L1024.99 204.253C1018.56 201.556 1011.58 199.938 1004.29 199.642L1005.1 173.68C1015.33 174.062 1025.24 176.29 1034.5 180.188ZM1001.88 173.627C1002.69 173.627 1003.49 173.627 1004.29 173.662L1003.47 199.625C1002.94 199.625 1002.4 199.607 1001.86 199.607C994.799 199.607 988.017 200.843 981.688 203.122L973.366 178.587C982.408 175.333 992.002 173.645 1001.86 173.645L1001.88 173.627ZM972.629 178.848L980.951 203.383C973.081 206.341 965.948 210.9 959.92 216.695L942.807 197.71C951.531 189.271 961.661 182.902 972.612 178.83L972.629 178.848ZM940.496 200.042C941.065 199.451 941.651 198.859 942.238 198.285L959.35 217.269C953.808 222.733 949.237 229.276 945.938 236.532L923.199 225.622C927.419 216.243 933.246 207.594 940.496 200.042ZM922.847 226.387L945.586 237.298C942.355 244.676 940.429 252.802 940.111 261.328L915.128 260.476C915.547 248.521 918.192 236.985 922.847 226.37V226.387ZM915.061 263.834C915.061 262.999 915.061 262.164 915.095 261.328L940.078 262.164C940.078 262.721 940.061 263.277 940.061 263.834C940.061 271.491 941.35 278.834 943.728 285.638L920.235 294.634C916.836 284.889 915.061 274.501 915.061 263.834ZM920.503 295.417L943.996 286.421C946.842 294.269 951.129 301.386 956.504 307.424L938.236 325.208C930.399 316.455 924.421 306.345 920.486 295.4L920.503 295.417ZM940.479 327.626C939.91 327.035 939.341 326.426 938.788 325.817L957.056 308.033C961.025 312.366 965.563 316.142 970.553 319.187L958.597 342.069C952.05 338.154 945.955 333.299 940.479 327.609V327.626ZM1088.1 427.926H915.614L958.848 345.114C961.678 346.733 964.592 348.194 967.572 349.482L964.525 357.191C963.838 356.964 963.101 356.843 962.331 356.843C958.329 356.843 955.097 360.218 955.097 364.36C955.097 368.501 958.346 371.877 962.331 371.877C966.316 371.877 969.565 368.501 969.565 364.36C969.565 361.297 967.807 358.652 965.261 357.486L968.309 349.795C977.837 353.797 988.034 356.094 998.55 356.477L998.298 364.36C994.38 364.447 991.232 367.788 991.232 371.877C991.232 375.966 994.481 379.394 998.466 379.394C1002.45 379.394 1005.7 376.019 1005.7 371.877C1005.7 367.944 1002.8 364.725 999.102 364.377L999.353 356.477C1000.19 356.495 1001.01 356.512 1001.85 356.512C1011.98 356.512 1021.84 354.772 1031.13 351.413L1033.73 359.087C1031.27 360.288 1029.56 362.881 1029.56 365.909C1029.56 370.067 1032.81 373.426 1036.79 373.426C1040.78 373.426 1044.03 370.05 1044.03 365.909C1044.03 361.767 1040.78 358.391 1036.79 358.391C1035.97 358.391 1035.2 358.531 1034.47 358.792L1031.87 351.152C1036.34 349.499 1040.66 347.463 1044.83 345.08L1088.07 427.891L1088.1 427.926ZM1045.12 342.087L1033.16 319.204C1037 316.855 1040.56 314.088 1043.81 310.974L1060.92 329.958C1056.05 334.656 1050.76 338.728 1045.12 342.104V342.087ZM1063.23 327.626C1062.66 328.218 1062.08 328.81 1061.49 329.384L1044.38 310.399C1049.92 304.935 1054.49 298.393 1057.79 291.136L1080.53 302.047C1076.31 311.426 1070.48 320.074 1063.23 327.626ZM1080.88 301.281L1058.14 290.371C1061.38 282.993 1063.3 274.866 1063.62 266.34L1088.6 267.175C1088.18 279.13 1085.54 290.667 1080.88 301.281Z",
    fill: "#DFD3BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1217.32 323.102H1124.27V464.781H1217.32V323.102Z",
    fill: "#DFD3BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1296.74 378.176H1203.69V463.963H1296.74V378.176Z",
    fill: "#DFD3BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M895.052 365.578H842.859V437.583H895.052V365.578Z",
    fill: "#DFD3BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1236.6 188.365H1170.79V464.78H1236.6V188.365Z",
    fill: "#DFD3BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1344.97 464.781H1258.16V303.369H1323.97L1344.97 464.781Z",
    fill: "#DFD3BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1382.97 427.926H1306.95V464.764H1382.97V427.926Z",
    fill: "#DFD3BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1221.86 130.611H1219.58V205.731H1221.86V130.611Z",
    fill: "#DFD3BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1229.51 146.742H1227.23V221.862H1229.51V146.742Z",
    fill: "#DFD3BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1214.91 157.113H1212.63V232.233H1214.91V157.113Z",
    fill: "#DFD3BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1292.62 290.336H1261.56V315.759H1292.62V290.336Z",
    fill: "#DFD3BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1289.24 281.27H1264.98V295.556H1289.24V281.27Z",
    fill: "#DFD3BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1310.92 297.783H1304.96V308.05H1310.92V297.783Z",
    fill: "#DFD3BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1321.54 288.404H1313.03V308.033H1321.54V288.404Z",
    fill: "#DFD3BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M921.494 250.713H842.594V514.999H921.494V250.713Z",
    fill: "#524335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M927.392 252.277H836.703V254.957H927.392V252.277Z",
    fill: "#524335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M924.931 289.412H839.148V292.074H924.931V289.412Z",
    fill: "#524335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M924.931 325.363H839.148V328.026H924.931V325.363Z",
    fill: "#524335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M924.931 361.312H839.148V363.975H924.931V361.312Z",
    fill: "#524335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M924.931 397.264H839.148V399.926H924.931V397.264Z",
    fill: "#524335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M924.931 433.213H839.148V435.875H924.931V433.213Z",
    fill: "#524335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M924.931 469.164H839.148V471.826H924.931V469.164Z",
    fill: "#524335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M930.386 244.986H833.703V252.295H930.386V244.986Z",
    fill: "#524335"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M857.9 263.641H849.695V284.748H857.9V263.641Z",
    fill: "#524335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M876.236 263.641H868.031V284.748H876.236V263.641Z",
    fill: "#524335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M894.572 263.641H886.367V284.748H894.572V263.641Z",
    fill: "#524335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M912.908 263.641H904.703V284.748H912.908V263.641Z",
    fill: "#524335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M857.9 298.164H849.695V319.271H857.9V298.164Z",
    fill: "#524335"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M876.236 298.164H868.031V319.271H876.236V298.164Z",
    fill: "#524335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M894.572 298.164H886.367V319.271H894.572V298.164Z",
    fill: "#524335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M912.908 298.164H904.703V319.271H912.908V298.164Z",
    fill: "#524335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M857.9 334.115H849.695V355.223H857.9V334.115Z",
    fill: "#524335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M876.236 334.115H868.031V355.223H876.236V334.115Z",
    fill: "#524335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M894.572 334.115H886.367V355.223H894.572V334.115Z",
    fill: "#524335"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M912.908 334.115H904.703V355.223H912.908V334.115Z",
    fill: "#524335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M857.9 370.066H849.695V391.174H857.9V370.066Z",
    fill: "#524335"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M876.236 370.066H868.031V391.174H876.236V370.066Z",
    fill: "#524335"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M894.572 370.066H886.367V391.174H894.572V370.066Z",
    fill: "#524335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M912.908 370.066H904.703V391.174H912.908V370.066Z",
    fill: "#524335"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M857.9 406.016H849.695V427.123H857.9V406.016Z",
    fill: "#524335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M876.236 406.016H868.031V427.123H876.236V406.016Z",
    fill: "#524335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M894.572 406.016H886.367V427.123H894.572V406.016Z",
    fill: "#524335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M912.908 406.016H904.703V427.123H912.908V406.016Z",
    fill: "#524335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M857.9 441.967H849.695V463.074H857.9V441.967Z",
    fill: "#524335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M876.236 441.967H868.031V463.074H876.236V441.967Z",
    fill: "#524335"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M894.572 441.967H886.367V463.074H894.572V441.967Z",
    fill: "#524335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M912.908 441.967H904.703V463.074H912.908V441.967Z",
    fill: "#524335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M857.9 477.916H849.695V499.023H857.9V477.916Z",
    fill: "#524335"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M876.236 477.916H868.031V499.023H876.236V477.916Z",
    fill: "#524335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M894.572 477.916H886.367V499.023H894.572V477.916Z",
    fill: "#524335"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M912.908 477.916H904.703V499.023H912.908V477.916Z",
    fill: "#524335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M874.412 234.912H847.57V248.641H874.412V234.912Z",
    fill: "#524335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M876.233 234.512H845.758V236.861H876.233V234.512Z",
    fill: "#524335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M729.52 514.998H624.414V263.884L729.52 237.174V514.998Z",
    fill: "#524335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.015 259.482H619.789V515.016H629.015V259.482Z",
    fill: "#524335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M655.305 252.277H646.062V514.998H655.305V252.277Z",
    fill: "#524335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M681.562 244.795H672.336V514.998H681.562V244.795Z",
    fill: "#524335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M707.851 238.705H698.625V514.998H707.851V238.705Z",
    fill: "#524335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M734.125 232.215H724.898V514.999H734.125V232.215Z",
    fill: "#524335"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M643.663 280.92H631.406V300.322H643.663V280.92Z",
    fill: "#524335"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M669.952 280.92H657.695V300.322H669.952V280.92Z",
    fill: "#524335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M696.226 280.92H683.969V300.322H696.226V280.92Z",
    fill: "#524335"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M722.499 280.92H710.242V300.322H722.499V280.92Z",
    fill: "#524335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643.663 314.713H631.406V334.115H643.663V314.713Z",
    fill: "#524335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.952 314.713H657.695V334.115H669.952V314.713Z",
    fill: "#524335"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M696.226 314.713H683.969V334.115H696.226V314.713Z",
    fill: "#524335"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M722.499 314.713H710.242V334.115H722.499V314.713Z",
    fill: "#524335"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M643.663 348.506H631.406V367.908H643.663V348.506Z",
    fill: "#524335"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M669.952 348.506H657.695V367.908H669.952V348.506Z",
    fill: "#524335"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M696.226 348.506H683.969V367.908H696.226V348.506Z",
    fill: "#524335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M722.499 348.506H710.242V367.908H722.499V348.506Z",
    fill: "#524335"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M643.663 382.281H631.406V401.683H643.663V382.281Z",
    fill: "#524335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.952 382.281H657.695V401.683H669.952V382.281Z",
    fill: "#524335"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M696.226 382.281H683.969V401.683H696.226V382.281Z",
    fill: "#524335"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M722.499 382.281H710.242V401.683H722.499V382.281Z",
    fill: "#524335"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M643.663 416.074H631.406V435.476H643.663V416.074Z",
    fill: "#524335"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M669.952 416.074H657.695V435.476H669.952V416.074Z",
    fill: "#524335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M696.226 416.074H683.969V435.476H696.226V416.074Z",
    fill: "#524335"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M722.499 416.074H710.242V435.476H722.499V416.074Z",
    fill: "#524335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643.663 449.867H631.406V469.269H643.663V449.867Z",
    fill: "#524335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.952 449.867H657.695V469.269H669.952V449.867Z",
    fill: "#524335"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M696.226 449.867H683.969V469.269H696.226V449.867Z",
    fill: "#524335"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M722.499 449.867H710.242V469.269H722.499V449.867Z",
    fill: "#524335"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M643.663 483.66H631.406V503.062H643.663V483.66Z",
    fill: "#524335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.952 483.66H657.695V503.062H669.952V483.66Z",
    fill: "#524335"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M696.226 483.66H683.969V503.062H696.226V483.66Z",
    fill: "#524335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M722.499 483.66H710.242V503.062H722.499V483.66Z",
    fill: "#524335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.602 275.928V278.538H322.09V285.968H366.078V515H293.909V297.905V285.968V278.538H291.297V275.928H324.602Z",
    fill: "#524335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.36 379.967H447.539V515.016H509.36V379.967Z",
    fill: "#524335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.368 349.01H178.117V515.015H228.368V349.01Z",
    fill: "#524335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.161 383.586H218.406V514.998H273.161V383.586Z",
    fill: "#524335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.423 342.346H196.203V362.218H218.423V342.346Z",
    fill: "#524335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.543 381.428H222.172V386.283H280.543V381.428Z",
    fill: "#524335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.667 439.949H267.281V515H328.667V439.949Z",
    fill: "#524335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.807 378.906H68.875V514.999H118.807V378.906Z",
    fill: "#524335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.2359 446.734H25.5469V514.998H91.2359V446.734Z",
    fill: "#524335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.4311 490.115H-13.6875V514.999H83.4311V490.115Z",
    fill: "#524335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.189 464.779H118.812V514.999H196.189V464.779Z",
    fill: "#524335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.365 493.369H345.82V514.999H466.365V493.369Z",
    fill: "#524335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M680.075 493.369H559.531V514.999H680.075V493.369Z",
    fill: "#524335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.655 429.838H415.842L396.469 504.175H461.655V429.838Z",
    fill: "#524335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.109 321.674H482.836V404.137H484.109V321.674Z",
    fill: "#524335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.927 349.586H489.219V398.257H490.927V349.586Z",
    fill: "#524335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.268 358.199H480.094V382.282H503.268V358.199Z",
    fill: "#524335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.865 356.336H476.172V358.494H506.865V356.336Z",
    fill: "#524335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.008 445.344H498.109V515H573.008V445.344Z",
    fill: "#524335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.796 368.674H558.672V503.062H606.796V368.674Z",
    fill: "#524335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M823.492 393.941H746.617V515H823.492V393.941Z",
    fill: "#524335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M810.158 470.4H722.5V515.017H810.158V470.4Z",
    fill: "#524335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M876.233 499.043H819.234V515.017H876.233V499.043Z",
    fill: "#524335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M999.696 470.4H907.031V515.017H999.696V470.4Z",
    fill: "#524335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M943.93 515H1059.25V353.606H943.93V515Z",
    fill: "#524335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M940.969 353.588H1065.98V347.393H940.969V353.588Z",
    fill: "#524335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1003.48 363.332H1054.15V330.601H1003.48V363.332Z",
    fill: "#524335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M978.408 350.508H986.914V330.601H978.408V350.508Z",
    fill: "#524335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M960.523 350.508H969.883V330.601H960.523V350.508Z",
    fill: "#524335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1138.55 515H1229.82V279.286H1138.55V515Z",
    fill: "#524335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1135.93 281.879H1232.4V275.214H1135.93V281.879Z",
    fill: "#524335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1141.59 298.357H1226.73V266.688H1141.59V298.357Z",
    fill: "#524335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1186.5 288.334H1220.22V253.741H1186.5V288.334Z",
    fill: "#524335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1200.71 263.485H1220.22V245.283H1206.24L1200.71 263.485Z",
    fill: "#524335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1210.46 270.725H1212.35V230.163H1210.46V270.725Z",
    fill: "#524335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1209.73 228.057C1209.73 229.223 1210.48 230.162 1211.42 230.162C1212.36 230.162 1213.11 229.223 1213.11 228.057C1213.11 226.891 1212.36 225.951 1211.42 225.951C1210.48 225.951 1209.73 226.891 1209.73 228.057Z",
    fill: "#524335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1258.16 417.693H1217.3V515H1258.16V417.693Z",
    fill: "#524335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1147.53 370.24H1100.95V514.999H1147.53V370.24Z",
    fill: "#524335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1124.27 514.999H1058.65V437.582L1114.02 463.074L1124.27 514.999Z",
    fill: "#524335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1344.97 472.959H1244.75V515H1344.97V472.959Z",
    fill: "#524335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1366.17 347.148H1307.95V514.998H1366.17V347.148Z",
    fill: "#524335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1449 483.66H1352.55V514.999H1449V483.66Z",
    fill: "#524335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1368.82 344.068H1304.96V349.567H1368.82V344.068Z",
    fill: "#524335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1358.36 320.387H1357.09V354.214H1358.36V320.387Z",
    fill: "#524335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1349.86 324.668H1348.59V351.796H1349.86V324.668Z",
    fill: "#524335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1387.71 410.385H1361.76V487.28H1398.78L1387.71 410.385Z",
    fill: "#524335"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_644_7325"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1533,
    height: 515,
    fill: "white",
    transform: "translate(-84)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterBg);
export default __webpack_public_path__ + "static/media/footer_bg.1f0de728e2cf1edf122879901af033b0.svg";
export { ForwardRef as ReactComponent };